import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  wrapper: {
    transition: '0.5s',
  },
  loading: {
    opacity: 0,
  },
});

const TotalResults = ({ count, total, className, isLoading = false }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <span
      className={classNames(
        classes.wrapper,
        isLoading && classes.loading,
        className
      )}
    >
      {count} {t('dataGrid.pageOf')} {total} {t('dataGrid.results')}
    </span>
  );
};

TotalResults.propTypes = {
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default TotalResults;
